module.exports = __webpack_public_path__ + "static/media/ledlamp.862c10e9.png";